'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import * as OrientationTypes from 'DesignData/enums/OrientationTypes';
import { rootFolderDropTarget } from 'DesignFinderUI/components/dnd/FolderDragDrop';
/**
 * @class RootFolderDropTarget
 */

class RootFolderDropTarget extends PureComponent {
  componentDidUpdate(prevProps) {
    if (this.props.isOver !== prevProps.isOver) {
      this.props.onDragOverChange(this.props.isOver);
    }
  }

  render() {
    const {
      connectDropTarget,
      orientation
    } = this.props;
    const cx = classNames('root-folder-drop-target', orientation === OrientationTypes.TOP && 'is--orientation--top', orientation === OrientationTypes.BOTTOM && 'is--orientation--bottom', orientation === OrientationTypes.LEFT && 'is--orientation--left', orientation === OrientationTypes.RIGHT && 'is--orientation--right');
    return connectDropTarget( /*#__PURE__*/_jsx("div", {
      className: cx,
      "data-test-id": orientation === OrientationTypes.TOP ? 'finder-root-folder-deselection-target' : ''
    }));
  }

}
/**
 * Statics
 */


RootFolderDropTarget.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  onDragOverChange: PropTypes.func,
  orientation: PropTypes.oneOf(Object.values(OrientationTypes || {}))
};
RootFolderDropTarget.defaultProps = {
  onDragOverChange: emptyFunction,
  orientation: OrientationTypes.CENTER
};
/**
 * Export
 */

export default rootFolderDropTarget(RootFolderDropTarget);